import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import NavBar from '../../Components/NavBar/navbar';
import './Auth.css';
import { API_ENDPOINTS } from '../../utils/config';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('Verifying your email…');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(API_ENDPOINTS.VERIFY_EMAIL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (res.ok) {
          setStatus('ok');
          setMessage('Email verified. You can create SDK API tokens from Account settings.');
        } else {
          setStatus('error');
          setMessage(data.error || 'Verification failed.');
        }
      } catch (err) {
        if (!cancelled) {
          setStatus('error');
          setMessage('Server not responding. Try again later.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="auth-page">
      <NavBar />
      <div className="auth-page-main">
        <div className="auth-container">
          <div className="auth-box">
            <div className="auth-brand">
              Evolv<span>e<sup>x</sup></span>
            </div>
            <h2>Email verification</h2>
            <p className="auth-subtitle">Confirming your address for SDK API tokens</p>
            {status === 'ok' && <div className="auth-success">{message}</div>}
            {status === 'error' && <div className="auth-error">{message}</div>}
            {status === 'pending' && <p className="auth-subtitle">{message}</p>}
            <p className="auth-footer">
              <Link to="/auth/login">Sign in</Link>
              {' · '}
              <Link to="/account">Account</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
